import React, { useCallback } from 'react';
import { Col, DatePicker, Form, Row, TimePicker } from 'antd';
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import { FORMAT_DATE } from '../../../../constants/common';
import { CARTNER_CONVOS } from '../../../../constants/define/translation';
import { ValidTime } from '../../tour-trash/tab-pane/Details';
import { ButtonActionPage } from '../../../atoms/button/ButtonActionPage';
import { IconTime, IconDate } from '../../../../assets';

interface ScheduleDateTimePickerSectionProps {
  form: any;
  startTime: any;
  endTime: any;
  onChangeStartTime: (value: moment.Moment | null) => void;
  onChangeEndTime: (value: moment.Moment | null) => void;
  onHandleChangeDate: () => void;
  validTime: ValidTime;
}

export const ScheduleDateTimePickerSection = (props: ScheduleDateTimePickerSectionProps) => {
  const { t } = useTranslation(CARTNER_CONVOS);
  const { form, startTime, endTime, onChangeStartTime, onChangeEndTime, onHandleChangeDate, validTime } = props;

  const { validateStatus, help, isCheckStartDate } = validTime;

  const disabledStartDate = useCallback(
    date => {
      const now = moment().format(FORMAT_DATE);

      const isBeforeNow = moment(date).diff(now, 'second') < 0;

      return isBeforeNow;
    },
    [form],
  );

  const disabledEndDate = useCallback(
    date => {
      const startDateVal = form.getFieldValue('startDate');
      const now = moment().format(FORMAT_DATE);
      const isBeforeNow = moment(date).diff(now, 'second') < 0;
      const isBeforeStartDate =
        startDateVal && moment(date).diff(moment(startDateVal).format(FORMAT_DATE), 'second') < 0;

      return isBeforeNow || isBeforeStartDate;
    },
    [form],
  );

  return (
    <>
      <Row className="row-datetime-picker">
        <Col span={11}>
          <Form.Item
            name="startTime"
            validateStatus={isCheckStartDate ? validateStatus : undefined}
            help={isCheckStartDate ? help : undefined}
            initialValue={startTime}
            label={t('form.time.startTimePlaceholder')}
          >
            <TimePicker
              placeholder={t('form.time.startTimePlaceholder')}
              use12Hours
              format="hh:mm A"
              value={startTime}
              onChange={onChangeStartTime}
              showNow={false}
              minuteStep={15}
              style={{ borderRadius: 6, overflow: 'hidden' }}
              suffixIcon={
                <img
                  src={IconTime}
                  alt="custom-icon"
                  style={{
                    width: 34,
                    height: 34,
                    backgroundColor: 'rgba(203, 203, 203, 1)',
                  }}
                />
              }
            />
          </Form.Item>
        </Col>
        <Col span={11} offset={2}>
          <Form.Item
            name="startDate"
            validateStatus={isCheckStartDate ? validateStatus : undefined}
            label={t('form.time.startDatePlaceholder')}
          >
            <DatePicker
              placeholder={t('form.time.startDatePlaceholder')}
              format="ll"
              disabledDate={disabledStartDate}
              onChange={onHandleChangeDate}
              suffixIcon={
                <img
                  src={IconDate}
                  alt="custom-icon"
                  style={{
                    width: 34,
                    height: 34,
                    backgroundColor: 'rgba(203, 203, 203, 1)',
                  }}
                />
              }
              style={{ borderRadius: 6, overflow: 'hidden' }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={11}>
          <Form.Item
            name="endTime"
            label={t('form.time.endTimePlaceholder')}
            validateStatus={!isCheckStartDate ? validateStatus : undefined}
            help={!isCheckStartDate ? help : undefined}
            initialValue={endTime}
          >
            <TimePicker
              placeholder={t('form.time.endTimePlaceholder')}
              use12Hours
              format="hh:mm A"
              value={endTime}
              onChange={onChangeEndTime}
              showNow={false}
              minuteStep={15}
              style={{ borderRadius: 6, overflow: 'hidden' }}
              suffixIcon={
                <img
                  src={IconTime}
                  alt="custom-icon"
                  style={{
                    width: 34,
                    height: 34,
                    backgroundColor: 'rgba(203, 203, 203, 1)',
                  }}
                />
              }
            />
          </Form.Item>
        </Col>
        <Col span={11} offset={2}>
          <Form.Item
            name="endDate"
            label={t('form.time.endDatePlaceholder')}
            validateStatus={!isCheckStartDate ? validateStatus : undefined}
          >
            <DatePicker
              placeholder={t('form.time.endDatePlaceholder')}
              format="ll"
              disabledDate={disabledEndDate}
              onChange={onHandleChangeDate}
              style={{ borderRadius: 6, overflow: 'hidden' }}
              suffixIcon={
                <img
                  src={IconDate}
                  alt="custom-icon"
                  style={{
                    width: 34,
                    height: 34,
                    backgroundColor: 'rgba(203, 203, 203, 1)',
                  }}
                />
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Row justify="end">
        <ButtonActionPage
          disabled={
            form.getFieldValue('startDate') == null ||
            form.getFieldValue('endDate') == null ||
            form.getFieldValue('startTime') == null ||
            form.getFieldValue('endTime') == null
          }
          text={
            <text style={{ fontSize: 12, letterSpacing: 0.96, fontFamily: 'DIN Next79', fontWeight: 700 }}>
              {t('form.btnSubmit').toUpperCase()}
            </text>
          }
          id="1"
          className="btn-submit-generate-access-code mt-4"
          htmlType="submit"
        />
      </Row>
    </>
  );
};
